<!-- 
task == 2 // برای ورودی های جدید
task == 3 // برای تایید های من
task == 4 // برای در جریان
task == 5 // همه درخواست ها  
task == 6 // همه  زباله   
finance type : 
 1 => تراکنش ثبت شده دز سیستم   
 2 => تراکنش عادی   
 3 => سود مشارکت 
-->
<div class="my-container" [hidden]="!loading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<div class='alert alert-danger malert-danger alert-dismissible fade in' *ngIf="err_validation">{{ err }}</div>
<div class='alert alert-danger malert-danger alert-dismissible fade in' *ngIf="err_internet_validation">{{
  err_internet_text }} <span (click)="load_data(1,1,1)"><i class="fas fa-sync icon"></i></span></div>

<!--
<div style='text-align:center;padding-top:0.5rem'>
  <div *ngFor="let x of list_process" class='style-box' [routerLink]="['/home','sale',product,x.sale_process_id]"
    routerLinkActive='active1'>
    {{ x.sale_process_title }}
  </div>
</div>
-->

<div class="row" style="direction: rtl;display: flex !important;">
  <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-12 padding0">
    <input class="search_box" name="search_all" [(ngModel)]="search_all" (keyup)="check_access(4,1,'',1,2)"
      placeholder="جستجو..." autocomplete="off" style="width:100%">
  </div>
  <div class="col-xl-8 col-lg-8 col-md-7 col-sm-8 col-xs-12 padding0">
    <div [ngStyle]="{'direction' : lang == 2 ? 'ltr' : 'rtl'}" class="service_pager">
      <span>
        <button (click)='open_modal_price()' class='search_bar_button'>قیمت</button>
        <button (click)='load_data2()' class='search_bar_button'>همه درخواست ها</button>
        <button (click)='insert()' *ngIf="lang == 1 && code == 1" class='search_bar_button new1'>جدید</button>
        <button (click)='search()' *ngIf="lang == 1" class='search_bar_button' class="search1">جستجو</button>
        <a id="download" href="{{ site }}/export/{{ export_code }}.xlsx" *ngIf="show_excel == true">
          <button [ngClass]="{en_navigation_number:lang==2}">
            <span *ngIf="lang == 2">Excel</span>
            <span *ngIf="lang == 1">خروجی اکسل</span>
          </button>
        </a>
        <button (click)="check_access(4,4,0,1,1)" [disabled]='next_status'><i class="fas fa-fast-forward"></i></button>
        <button (click)="check_access(4,2,0,1,1)" [disabled]='next_status'><i class="fas fa-forward"></i></button>
        <button (click)="check_access(4,3,0,1,1)" [disabled]='pre_status'><i class="fas fa-backward"></i></button>
        <button (click)="check_access(4,5,0,1,1)" [disabled]='pre_status'><i class="fas fa-fast-backward"></i></button>
        <div class='navigation' [ngClass]="{en_navigation_number:lang==2}"><span> {{ page_number_first }}
          </span><span>-</span><span> {{ page_number_second }} </span><span> of </span><span>
            {{ count_total }} </span>
        </div>
      </span>
    </div>
  </div>
</div>




<div class="content-body control-content-body" [ngClass]="{content_body_en:lang==2}"
  style='overflow-x:auto;direction:rtl;'>
  <mat-table [dataSource]="dataSource" style='min-width:100%' class='table-scroll mat_table_fa_without_scroll pe1'
    [ngClass]="{mat_table_en_without_scroll:lang==2,en1:lang == 2}" [ngStyle]="lang == 2 && {direction:'ltr'}">
    <ng-container matColumnDef="row">
      <mat-header-cell *matHeaderCellDef style='max-width:40px'>
        <span *ngIf="lang == 1">ردیف</span>
        <span *ngIf="lang == 2">#</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" style='max-width:40px'
        [ngStyle]="{backgroundColor:x.sale_process_color}">{{ i
        + page_number_first }}</mat-cell>
      <mat-footer-cell *matFooterCellDef style='max-width:40px'>-
      </mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="customer">
      <mat-header-cell *matHeaderCellDef style="max-width: 250px;min-width: 250px;">
        <span *ngIf="lang == 1">سفارش دهنده</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" style="max-width: 250px;min-width: 250px;"
        [ngStyle]="{backgroundColor:x.sale_process_color}">
        <span class="right" style="direction: rtl;float: right;" (click)="change_task2(i,x.pre_factor_lsf_order_id)">
          {{x.user_title
          | substr:0:25 }} </span>

        <span style="float: left;font-size: 1rem;" (click)="get_menu1(x.pre_factor_lsf_order_id)"
          [matMenuTriggerFor]="menu"><i class="fas fa-info-circle icon"></i></span>

      </mat-cell>
      <mat-footer-cell *matFooterCellDef style="max-width: 250px;min-width: 250px;">-
      </mat-footer-cell>
    </ng-container>

    <mat-menu #menu="matMenu" class="ckd-mat-menu-panel" xPosition="before">
      <table class="table table-bordered" (click)="$event.stopPropagation()">
        <tr>
          <td class="cursor" (click)="print(order_id)">
            <a target="_blank">
              پیش فاکتور
            </a>
          </td>
        </tr>
        <tr>
          <td>
            <a [href]="serverService.get_currenct_site()+'/sale-invoice/'+ order_id" target="_blank">
              فاکتور رسمی
            </a>
          </td>
        </tr>
      </table>
    </mat-menu>

    <ng-container matColumnDef="code">
      <mat-header-cell *matHeaderCellDef>
        <span *ngIf="lang == 1">شماره فاکتور</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" (click)="change_task2(i,x.pre_factor_lsf_order_id)">{{
        x.pre_factor_lsf_order_code_factor }}</mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="price">
      <mat-header-cell *matHeaderCellDef>
        <span *ngIf="lang == 1">قیمت سازه</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" (click)="change_task2(i,x.pre_factor_lsf_order_id)">{{
        x.pre_factor_lsf_order_price | number }}</mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="bana">
      <mat-header-cell *matHeaderCellDef>
        <span *ngIf="lang == 1">زیر بنای کل m<sup>2</sup></span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" (click)="change_task2(i,x.pre_factor_lsf_order_id)">{{
        x.pre_factor_lsf_order_meter | number }}</mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>


    <ng-container matColumnDef="price_all">
      <mat-header-cell *matHeaderCellDef>
        <span *ngIf="lang == 1"> قیمت کل با تخفیف </span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" (click)="change_task2(i,x.pre_factor_lsf_order_id)">{{
        x.pre_factor_lsf_order_price_all | number }}</mat-cell>
      <mat-footer-cell *matFooterCellDef>{{ sum_price_all | number }}</mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="price_all_m2">
      <mat-header-cell *matHeaderCellDef>
        <span *ngIf="lang == 1">قیمت m2 با تخفیف</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" (click)="change_task2(i,x.pre_factor_lsf_order_id)">{{
        x.pre_factor_lsf_order_price_all_m2 | number }}</mat-cell>
      <mat-footer-cell *matFooterCellDef>{{ price_all_m2 | number }}</mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="percent">
      <mat-header-cell *matHeaderCellDef>
        <span *ngIf="lang == 1"> ارزش افزوده </span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" (click)="change_task2(i,x.pre_factor_lsf_order_id)">{{
        x.pre_factor_lsf_order_percent | number }}</mat-cell>
      <mat-footer-cell *matFooterCellDef>{{ sum_percent | number }}</mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="price_final">
      <mat-header-cell *matHeaderCellDef>
        <span *ngIf="lang == 1"> قیمت تقریبی کل </span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" (click)="change_task2(i,x.pre_factor_lsf_order_id)">{{
        x.pre_factor_lsf_order_price_final | number }}</mat-cell>
      <mat-footer-cell *matFooterCellDef style='max-width:110px'>
        {{ sum | number}}
      </mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="payment">
      <mat-header-cell *matHeaderCellDef>
        <span *ngIf="lang == 1"> پرداخت شده </span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" (click)="change_task2(i,x.pre_factor_lsf_order_id)">{{
        x.payment | number }}</mat-cell>s
      <mat-footer-cell *matFooterCellDef style='max-width:110px'>
        {{ sum_payment | number}}
      </mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="status">
      <mat-header-cell *matHeaderCellDef style="max-width:80px">
        <span *ngIf="lang == 1"> وضعیت </span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" style="max-width:80px"
        (click)="change_task2(i,x.pre_factor_lsf_order_id)">{{
        x.sale_process_title }}</mat-cell>
      <mat-footer-cell *matFooterCellDef style='max-width:80px'></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="date">
      <mat-header-cell *matHeaderCellDef style="max-width:80px">
        <span *ngIf="lang == 1"> تاریخ ایجاد </span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" style="max-width:80px"
        (click)="change_task2(i,x.pre_factor_lsf_order_id)">{{
        x.pre_factor_lsf_order_date }}</mat-cell>
      <mat-footer-cell *matFooterCellDef style='max-width:80px'></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="creator">
      <mat-header-cell *matHeaderCellDef style="max-width:120px">
        <span *ngIf="lang == 1"> ایجاد کننده </span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" style="max-width:120px"
        (click)="change_task2(i,x.pre_factor_lsf_order_id)">{{
        x.creator_title }}</mat-cell>
      <mat-footer-cell *matFooterCellDef style='max-width:120px'></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="id">
      <mat-header-cell *matHeaderCellDef>
        <span *ngIf="lang == 1">شناسه</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" (click)="change_task2(i,x.pre_factor_lsf_order_id)">{{
        x.pre_factor_lsf_order_id }}</mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>


    <ng-container matColumnDef="operation">
      <mat-header-cell *matHeaderCellDef style="max-width: 200px;min-width: 200px;background-color: #f0f0f0;">
        <span *ngIf="lang == 1"> عملیات </span>
      </mat-header-cell>
      <mat-cell *matCellDef="let x;let i = index" style="max-width: 200px;min-width: 200px;">
        <span (click)="delete(x.pre_factor_lsf_order_id)"><i class="far fa-trash-alt icon"
            style='margin:0px 4px;'></i></span>
        <span (click)="back(i,x.pre_factor_lsf_order_id)" *ngIf="x.pre_factor_lsf_order_status == code && code > 1 "><i
            class="fas fa-reply-all icon" style='margin:0px 4px;'></i></span>
        <span (click)="change_task2(i,x.pre_factor_lsf_order_id)"><i class="fas fa-desktop icon"></i></span>
        <span (click)="print(x.pre_factor_lsf_order_id)"><i class="fas fa-print icon" style="margin: 0px 4px;"></i>
        </span>
        <span (click)="send_sms(x.user_id)">
          <i class="fas fa-unlock-alt icon"></i>
        </span>
        <span (click)="open_comment(x.pre_factor_lsf_order_id)">
          <i class="fas fa-comments" style="margin: 0px 4px; cursor: pointer; font-size: 13px;"></i>
        </span>
        <span (click)="open_payments(x.pre_factor_lsf_order_id)">
          <i class="fas fa-dollar-sign icon"></i>
        </span>
        <span (click)="open_exit(x.pre_factor_lsf_order_id)" *ngIf="x.sale_process_wharehouse == 1"><i
            class="fas fa-industry"></i></span>

        <span (click)="print(x.pre_factor_lsf_order_id)"><i class="fas fa-print icon" style="margin: 0px 4px;"></i>
        </span>

      </mat-cell>
      <mat-footer-cell *matFooterCellDef style='max-width:200px;min-width: 200px;'></mat-footer-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns" color="primary"></mat-header-row>
    <mat-row *matRowDef="let row;columns:displayedColumns;let i = index" (click)="mat_table_selectedRow = row"
      (mouseenter)="mat_table_hoverRow = row"
      [ngClass]="{'mat_table_selected': row === mat_table_selectedRow,'mat_table_hover': row === mat_table_hoverRow}"
      class="cursor"></mat-row>
    <mat-footer-row *matFooterRowDef="displayedColumns;sticky : true" color="primary"></mat-footer-row>
  </mat-table>

</div>
<!-- ************************************************************************************************************************************************ -->
<ngx-smart-modal #profile_user_modal identifier="profile_user_modal" class="pe" [ngClass]="{en:lang==2}"
  (onClose)="ModalClose()">
  <div class='col-md-12 pe' style='text-align:center' *ngIf="lang == 1"> مشخصات خریدار </div>
  <div class='col-md-12 en' style='margin-top:0px;' *ngIf="lang == 2"> --- </div>

  <div class='col-md-12 pe' *ngIf="lang == 1">
    شناسه کاربری : <span>{{ user_username }}</span>
  </div>

  <div class='col-md-12 pe' *ngIf="lang == 1">
    نام خریدار : <span>{{ user_fname }}</span>
  </div>
  <div class='col-md-12 pe' *ngIf="lang == 1">
    شماره همراه : <span>{{ user_cellphone }}</span>
  </div>

</ngx-smart-modal>

<ngx-smart-modal #modal_price identifier="modal_price" class="pe" [ngClass]="{en:lang==2}" (onClose)="ModalClose()"
  style='overflow-x:hidden !important'>
  <form #form_myModal="ngForm">
    <div style='text-align:center;padding:12px !important' *ngIf="lang == 1 ">
      <span>ويرايش</span>
    </div>
    <div class="row">
      <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' [ngClass]="{en:lang==2}">
        <label for="title" class='wh-label'>
          <span *ngIf="lang == 1"> قیمت سازه به تومان : </span>
          <input class='wh-input' name='shop_sazeh_price' [(ngModel)]='shop_sazeh_price' currencyMask autocomplete="off"
            required>
        </label>
      </div>

      <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' [ngClass]="{en:lang==2}">
        <label for="title" class='wh-label'>
          <span *ngIf="lang == 1"> قیمت پیچ سازه به تومان : </span>
          <input class='wh-input' name='shop_sazeh_price_price_lsf1' [(ngModel)]='shop_sazeh_price_price_lsf1'
            currencyMask autocomplete="off" required>
        </label>
      </div>

      <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' [ngClass]="{en:lang==2}">
        <label for="title" class='wh-label'>
          <span *ngIf="lang == 1"> قیمت پیچ بکس به تومان : </span>
          <input class='wh-input' name='shop_sazeh_price_price_lsf2' [(ngModel)]='shop_sazeh_price_price_lsf2'
            currencyMask autocomplete="off" required>
        </label>
      </div>


      <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' [ngClass]="{en:lang==2}">
        <label for="title" class='wh-label'>
          <span *ngIf="lang == 1"> قیمت رل بلت : </span>
          <input class='wh-input' name='shop_sazeh_price_price_lsf3' [(ngModel)]='shop_sazeh_price_price_lsf3'
            currencyMask autocomplete="off" required>
        </label>
      </div>

    </div>
    <div class="row">
      <div class='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12' style='margin-top:5px;text-align:center'
        *ngIf="lang == 1 ">
        <button class="btn_pe" [ngClass]="{btn_en:lang == 2}" (click)="update_price()">ويرايش</button>
      </div>
    </div>
  </form>
</ngx-smart-modal>